import { MemberInitialState, MembersModel } from "@purusha/purusha";

export const MembersInitialState: MembersModel = {
  list: [MemberInitialState],
  showModal: false
};
